<template>
    <z-basePage :title="'预算充值'">
        <div class="search-top">
            <!-- <span>BU名称</span>
            <el-select class="top-choose" v-model="bu_id" @change="search">
                <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                </z-limitOption>
            </el-select> -->

            <span>预算周期</span>
            <el-select class="top-choose" v-model="cycle_id" @change="search">
                <el-option v-for="item in cycle_list" :key="item.id" :value="item.id" :label="item.label">
                </el-option>
            </el-select>

            <!-- <div class="back-btn blue" @click="search">查询</div> -->
            <div class="back-btn blue" @click="link(2)">预算设置</div>
            <div class="back-btn orange shift" @click="pop.show = true">批量充值</div>
        </div>

        <div class="back-list page">
            <div class="list-head">
                <div>BU名称</div>
                <div>当期预算发放总额({{ task_curr.currency_name }})</div>
                <!-- <div>剩余预算(币)</div> -->
                <div>预算余额({{ task_curr.currency_name }})</div>
                <div>完成率</div>
                <div>操作</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item"  v-for="item in data" :key="item.id">
                    <div>{{ item.bu_name }}</div>
                    <div>{{ item.total_budget }}</div>
                    <!-- <div>{{ item.used_budget }}</div> -->
                    <div>{{ item.actual_balance }}</div>
                    <div>{{ `${(item.used_rate/100).toFixed(2)}%` }}</div>
                    <div v-if="cycle_id == now_cycleId" class="orange-text" @click="link(1,item.bu_id)">充值</div>
                    <div v-else>无</div>
                </div>
                <z-noData :list="data"></z-noData>
            </z-scrollDiv>
        </div>

        <!-- <z-windowPop :show="pop.show" :title="pop.title" :noBtns='true' @confirm="" @cancel="" >
            <div class="list-head">
                <div>BU名称</div>
                <div>预算总额({{ task_curr.currency_name }})</div>
                <div>已返还预算({{ task_curr.currency_name }})</div>
                <div>完成率</div>
                <div>操作</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item"  v-for="item in data" :key="item.id">
                    <div>{{ item.currency_name }}</div>
                    <div>{{ item.total_budget }}</div>
                    <div>{{ item.returned_budget }}</div>
                    <div>{{ `${(item.used_rate/100).toFixed(2)}%` }}</div>
                    <div class="orange-text" @click="link(1,item.id)">充值</div>
                </div>
                <z-noData :list="data"></z-noData>
            </z-scrollDiv>
        </z-windowPop> -->

        <z-windowPop :show="pop.show" :title="pop.title" 
        :noBtns='true' :width="'900px'" @cancel="closePop" v-form="'back-budget-all'">
            <div class="back-list pop-list">
                <div class="list-head">
                    <div>BU名称</div>
                    <div>预算余额({{ task_curr.currency_name }})</div>
                    <div>充值金额</div>
                </div>
                <z-scrollDiv class="main">
                    <div class="list-item"  v-for="item in data" :key="item.id">
                        <div>{{ item.bu_name }}</div>
                        <div>{{ item.actual_balance }}</div>
                        <el-input class="recharge-value" v-model="pop.bu_list[item.bu_id]" v-tar="pop.bu_list[item.bu_id]" rule="noTip_number"></el-input>
                    </div>
                    <!-- <z-noData :list="data"></z-noData> -->
                </z-scrollDiv>
            </div>
            <div class="pop-remark">
                <div class="title">备注</div>
                <div class="area">
                    <el-input 
                        type="textarea" 
                        :rows="4"
                        resize="none"
                        placeholder="请输入备注信息"
                        v-tar="pop.remark"
                        rule="noVal"
                        v-model="pop.remark">
                    </el-input>
                </div>
                <div class="btns">
                    <div class="back-btn orange" @click="rechargeAll">完成充值</div>
                    <div class="back-btn" @click="closePop">取消</div>
                </div>
            </div>
        </z-windowPop>
    </z-basePage>
</template>

<script>
    import { mapGetters } from "vuex"

    export default {
        data(){
            return {
                // bu_id:"",   //bu id
                // bu_list:[],   //bu选项

                cycle_id:"",   //当前周期id
                cycle_list:[], //周期选项

                data:[],   //获取的数据
                pop:{
                    show:false,
                    title:"预算批量充值",
                    bu_list:{},
                    remark:"管理员批量调整预算",
                },
            }
        },
        computed:{
            ...mapGetters(['task_curr']),
            now_cycleId(){
                return this.cycle_list.length?this.cycle_list[this.cycle_list.length - 1].id:"";
            }
            // data_list(){
            //     return this.data.filter(item=>{
            //         return item.currency_type != 20;
            //     })
            // }
            // datalist(){
            //     return this.data.list;
            // },
        },
        created(){
            this.fresh();
        },
        methods:{
            fresh(obj = {}){
                // this.$func.getBuList(true,list=>{ //拿bu选项
                //     this.bu_list = list;
                //     this.bu_id = this.bu_list[0] && this.bu_list[0].id;
                // })
                this.getBudgetCycle();  // 拿预算周期列表
            },

            getBudgetCycle(){
                let url = `api/admin/cycle/list/budget`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.cycle_list = res.res_data.map(item=>{
                            return {
                                id:item.id,
                                label:`${item.cycle_year}#${item.cycle_number}`,
                            }
                        });
                        this.cycle_id = this.now_cycleId;
                    }
                })
            },

            getData(obj = {}){
                // let url = `api/admin/curr_bgt_summary/${this.bu_id}`;
                // this.$http.get(url,{params:obj}).then(res=>{
                //     this.data = res.data;
                // });
                // let url = `api/admin/budget/recharge/list`;
                let url = `api/admin/all_budget/list`;
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },
            search(id){
                let obj = {
                    // bu_id:this.bu_id,
                    cycle_detail_id:id || this.cycle_id,
                }

                // if(obj.bu_id && obj.cycle_detail_id){
                if(obj.cycle_detail_id){
                    this.getData(obj);
                }

            },
            link(index,id){
                let str = this.$crypto.encrypt(id);
                if(index == 1){
                    this.$router.push({
                        name:'back-finance-budget-add',
                        params:{
                            id:str
                        }
                    });
                }else if(index == 2){   
                    this.$router.push({
                        name:'back-finance-budget-set',
                        params:{
                            id:str
                        }
                    });
                }
            },

            //****批量充值
            closePop(){  //关闭弹窗
                this.$form.clear("back-budget-all");
                this.pop.show = false;
                this.pop.bu_list = {};
                this.pop.remark = "管理员批量调整预算";
            },

            rechargeAll(){  //批量充值
                let res = this.$form.check("back-budget-all");
                if(!res){
                    return;
                }

                this.$func.loading(true);

                let obj = {};
                for(let key in this.pop.bu_list){
                    obj[key] = parseInt(this.pop.bu_list[key]);
                }

                let url = `api/admin/all_budget/recharge`;
                this.$http.post(url,{
                    bu_list:obj,
                    remark:this.pop.remark,
                })
                .then(res=>{
                    if(res.status == 200){
                        this.closePop();
                        this.search(this.now_cycleId);
                        this.successTip('批量充值成功');
                    }
                    this.$func.loading(false);
                })
                .catch(err=>{
                    this.errorTip('出错了');
                    this.$func.loading(false);
                })

            },
        },
        // beforeRouteLeave(to,from,next){  //离开页面之前
		// 	let res = this.$form.leave({name:'',path:to.path});
		// 	next(res);
		// },
    }
</script>

<style lang="less" scoped>
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 22%;
        }
        >div:nth-of-type(2){
            width: 22%;
        }
        >div:nth-of-type(3){
            width: 22%;
        }
        >div:nth-of-type(4){
            width: 22%;
        }
        >div:nth-of-type(5){
            width: 12%;
            cursor: pointer;
        }
    }
    .pop-list{
        .list-head,.list-item{
            >div:nth-of-type(1){
                width: 30%;
            }
            >div:nth-of-type(2){
                width: 30%;
            }
            >div:nth-of-type(3){
                width: 10%;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// page-budget-recharge.vue?61176b2e